<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
<div class="row">
  <div
    class="col-sm-12 span m-3 d-flex align-items-center justify-content-center flex-column"
  >
    <span>Dear {{ user_Info.username }}, </span>
    <span>We are trying to match truck with your requirement.</span>
    <span
      >You can check the updates of your quotes
      <a
        (click)="navigateToTrips()"
        style="
          text-decoration: underline;
          color: #f58634;
          cursor: pointer;
          font-size: 18px;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        "
        >here</a
      >.</span
    >
  </div>
</div>
